import * as DocumentForm from './components/DocumentForm.css';
export default {
    DocumentForm
};
